<div class="d-flex flex-column gap-2">
	@if(data()?.eventType && data()?.eventType?.eventTypeId == sessionEventTypeId){
	<common-message [closeable]="false">
		Please reach out to the program team before making any changes to the event.
	</common-message>
	}
	<table style='width:100%' class='pro-table pro-table-no-header pro-table-with-labels pro-table-without-border'>

		@if(data()?.acc; as acc) {
		<tr>
			<td>Accelerator </td>
			<td>
				{{acc.name}}
			</td>
		</tr>
		}
		<tr>
			<td>Language </td>
			<td>
				{{data()?.languageId == 1 ? 'English':'Spanish'}}
			</td>
		</tr>

		<tr>
			<td>Event Time </td>
			<td>
				<div class="d-flex flex-row align-items-center gap-2">
					<common-date-time-field [field]="form.startDate()"></common-date-time-field>
					<i class="fa-solid fa-arrow-right"></i>
					<common-date-time-field [field]="form.endDate()"></common-date-time-field>
					<div>{{form.duration()}}</div>
				</div>
			</td>
		</tr>
		@if(data()?.eventType?.toolNameLabelKey) {
		<tr>
			<td>Tool Enabled</td>
			<td>
				<div>
					<common-select-field [field]="form.toolEnabledSelection()"></common-select-field>
				</div>
				<div>
					@if(form.toolSelectionValue() == 'custom'){
					<div class="d-flex flex-row align-items-center gap-2 mt-1">
						<common-date-time-field [field]="form.toolStartDate()"></common-date-time-field>
						<i class="fa-solid fa-arrow-right"></i>
						<common-date-time-field [field]="form.toolEndDate()"></common-date-time-field>
						<div>{{form.toolDuration()}}</div>
					</div>
					}
				</div>

			</td>
		</tr>
		}
		<tr>
			<td>Host</td>
			<td>
				<div class="d-flex flex-row align-items-center gap-2">
					<staff-selector-widget [disabled]="!form.canEdit()" [data]="staffData()"
						[userId]="app.data().user.userId" [value]="{personId: form.hostPerson()?.personId}"
						(valueChange)="form.handleStaffValueChange($event)"></staff-selector-widget>

					@if(form.hostPerson()){
					<a class='link' (click)="form.openPersonDialog()">{{form.hostPerson()!.fullName}}</a>
					}
				</div>
			</td>
		</tr>
		<tr>
			<td>Location</td>
			<td>
				<div class="d-flex flex-row align-items-center gap-2">
					<common-select-field [field]="form.venue()"></common-select-field>
					<div>
						@if(form.venueValue() == 'In Person'){
						<venue-button
							[venue]="form.venueValues() ?{ venueId: form.venueValues()!.venueId, displayedName: form.venueValues()!.displayName}: undefined"
							(selection)='onVenueSelection($event)'>
						</venue-button>
						}
					</div>
				</div>
			</td>
		</tr>
		<tr>
			<td>Link</td>
			<td>
				<common-url-field [field]="form.link()"></common-url-field>
			</td>
		</tr>
		<tr>
			<td>Public Notes</td>
			<td>
				<common-text-field [field]="form.publicNotes()"></common-text-field>
			</td>
		</tr>

	</table>



	<common-button-row [center]="true">
		<button #eventFormAddBtn class="btn btn-primary">Add</button>
		<button class="btn btn-standard" (click)="closeDialog.emit()">Close</button>
	</common-button-row>
</div>